export const roleOptions = [
  { code: 'HK_SUPPORT', label: 'HK Administrator' },
  { code: 'GROUP_ADMIN', label: 'Group-Admin' },
  { code: 'SUPPORT', label: 'HK Support' },
  { code: 'CUSTOMER_MASTER', label: 'Customer Master' },
  { code: 'STORE_ADMIN', label: 'Store-Admin' },
  { code: 'MASTER_SALES_STAFF', label: 'Master Sales Staff' },
  { code: 'SALES_STAFF', label: 'Sales Staff' },
];

export const defaultPermissions = (toolNames) => {
  const map = {};

  roleOptions.forEach((role) => {
    map[role.label] = {};
    toolNames.forEach((toolName) => {
      map[role.label][toolName] = role.code === 'HK_SUPPORT';
    });
  });

  return map;
};

export { pageVariants, pageTransition } from '../utils/motionReveal';

